import React from 'react';
import ModalWrapper from '../group-shopping/components/GroupModal';

interface Brand {
  name: string;
}

interface VerificationResult {
  batch_id: string;
  expire_date?: string;
}

interface Props {
  show: boolean;
  handleClose: () => void;
  onSubmit?: () => void;
  initialValues?: any;
  selectedBrand: Brand;
  verificationResult: VerificationResult;
}

const CheckExpiryModal: React.FC<Props> = ({
  show,
  handleClose,
  selectedBrand,
  verificationResult,
}) => {
  const formatDate = (dateString: string | undefined) => {
    if (!dateString) return null;
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

  return (
    <ModalWrapper
      show={show}
      handleClose={handleClose}
      title="Update Order Shipping Information"
      size="md"
    >
      <div className="modal-body">
        <p className="mb-2">Brand Name: {selectedBrand?.name}</p>
        <p className="mb-2">Batch ID: {verificationResult.batch_id}</p>
        <p className="mb-2">
          Expiry Date: {formatDate(verificationResult?.expire_date)}
        </p>
      </div>
      <div className="modal-footer">
        <button
          className="trk-btn trk-btn--md trk-btn--primary"
          onClick={handleClose}
        >
          Close
        </button>
      </div>
    </ModalWrapper>
  );
};

export default CheckExpiryModal;
